import styled from 'styled-components';
import vehicleSteeringImage from '../../assets/images/vehicle_steering.png';

const StyledImg = styled.img.attrs({ src: vehicleSteeringImage })`
	position: relative;
	width: 60px;
	height: 60px;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	transition: transform ease 0.25s;
	-webkit-user-drag: none;
	user-select: none;
`;

export { StyledImg };
